<template lang="pug">
.content
  section#basic
    h2(v-t="'Setting.title01'")
    
    .language
      h3 {{ $t('Setting.langTitle') }}
      el-select(v-model="$i18n.locale" size="small" @change="setLocaleSetting")
        el-option(v-for="(lang, index) in languages" :key="index" :value="lang.code" :label="lang.label")
    
    .timezone
      h3 {{ $t('Setting.timezoneTitle') }}
      el-select.timezones(v-model="currentTimezone" size="medium" @change="setTimezone")
        el-option(v-for="tz in timezones" :key="tz.city" :value="tz.city"
        :label="'GMT' + tz.offset + ' ' + $t('MetaZones.'+tz.metazone) + ' (' + $t('TimezoneCities.'+tz.city) + ')'")
      el-tooltip(placement="top")
        div(slot="content" v-html="$t('Setting.timezoneTxt')")
        i.el-icon-question

</template>

<script>
import API from '@/api/companies'
export default {
  data () {
    return {
      languages: [
        {code: 'ja', label: '日本語'},
        {code: 'en', label: 'English'}
      ],
      timezones: [],
      currentTimezone: null
    }
  },
  title() {
    return this.$t('submenus.setting')
  },
  methods: {
    // 言語設定を保存
    setLocaleSetting: function() {
      this.$store.dispatch('setLocaleSetting', this.$i18n.locale)
    },
    loadTimezones() {
      const obj = this;
      API.getTimezones().then(function (response) {
        if (response && response.timezones) {
          obj.timezones = response.timezones.sort((a,b) => {
            const offsetA = parseInt(a.offset.replace(':',''));
            const offsetB = parseInt(b.offset.replace(':',''));
            if (offsetA !== offsetB) { return offsetA - offsetB }
            const stringA = (obj.$t('MetaZones.'+a.metazone)+obj.$t('TimezoneCities.'+a.city));
            const stringB = (obj.$t('MetaZones.'+b.metazone)+obj.$t('TimezoneCities.'+b.city));
            if (stringA < stringB) { return -1 }
            if (stringA > stringB) { return 1 }
            return 0;
          });
        } else {
          obj.timezones = [];
        }
        if (response && response.current_timezone) {
          obj.currentTimezone = response.current_timezone;
        }
      });
    },
    setTimezone() {
      API.setTimezone({tz: this.currentTimezone});
    }
  },
  mounted() {
    this.loadTimezones();
  }
}
</script>

<style lang="scss" scoped>
@import "../../styles/variables.scss";

section {

  &#basic {
    padding: 10px 40px 30px 40px;
  }

  h2 {
    font-size: 16px;
    font-weight: normal;

    i.caution {
      color: $caution;
      margin-left: 15px !important;
      font-size: 11px;
      vertical-align: middle;

      span { margin-left: 3px; }
    }
  }

  h3 {
    display: inline-block;
    width: 130px;
    font-size: 14px;
    font-weight: normal;
    margin-right: 30px;
  }

  .timezones {
    width: 500px;
  }

  i.el-icon-question {
    font-size: 20px;
    margin-left: 8px;
    cursor: pointer;
  }

}
</style>
